import { useGridDataContext } from '../../../shared/context/GridDataContext';
import { ComboBox } from '@airbus/components-react';
import { isSameDate } from '../../../shared/utils/dateUtils';
import { useEffect, useRef, useState } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import styles from './HtzEditCell.module.css';

import { applyInclusionFilterOnce, type DropdownOption } from './PPVLeaderUtilities';

export function PPVLeaderEditCell(props) {
  const { id, field, colDef, row } = props;
  const apiRef = useGridApiContext();
  const [, setRows] = useGridDataContext();

  const options = (colDef?.valueOptions ?? []) as DropdownOption[];
  const baseOptions = options.filter((item) => item?.value != null);
  const screenGridId = colDef?.screenGridId ?? row?.screenGridId;

  const [valueOptions, setValueOptions] = useState<DropdownOption[]>(baseOptions);
  const [selectedOption, setSelectedOption] = useState<DropdownOption | null>(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
     const fetchData = async () => {
      await applyInclusionFilterOnce({
        hasFetchedRef,
        htz: row?.htz,
        screenGridId,
        baseOptions,
        setValueOptions,
      });
    };

    fetchData();
  }, []);

  // displays change
  const handleValueChange = (event) => {
    setSelectedOption(event);
    const newValue = event.value; // The new value entered by the user
    apiRef.current.setEditCellValue({ id, field, value: newValue });
  };

  // TODO: saves value to grid state
  // not affecting the grid state yet
  const blurHandler = (targetValue) => {
    // const targetValue = event?.target?.value;
    apiRef.current.stopCellEditMode({ id, field, ignoreModifications: false });
    setRows((prestate) => {
      const oldRow = prestate.find((item) => item.id === row.id);

      if (isSameDate(oldRow[field], targetValue)) {
        return prestate;
      }
      if (oldRow[field] === targetValue) {
        return prestate;
      }
      oldRow[field] = targetValue;
      if (oldRow.status === 'N' || oldRow.status === 'C') {
        oldRow.touched[field] = true;
      }
      oldRow.status = oldRow.status || 'E';
      const newState = [...prestate];
      const index = newState.findIndex((item) => item.id === row.id);
      newState.splice(index, 1, oldRow);
      return newState;
    });
  };

  const handleEnterTabBlur = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      const target = e.target as HTMLInputElement;
      target.blur();
    }
  };

  return (
    <div className={styles.container}>
      <ComboBox
        className='h-100'
        id={id + '_' + field}
        hideClear={true}
        options={valueOptions}
        value={selectedOption}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        onChange={handleValueChange}
        onBlur={() => blurHandler(selectedOption?.value ?? null)}
        onKeyDown={handleEnterTabBlur}
      />
    </div>
  );
}
